@if (consent.showBanner()) {
  <section class="cb" role="region" [attr.aria-label]="strings['cookie_banner_label']">
    <div class="cb__head">
      <mat-icon class="cb__icon" aria-hidden="true">cookie</mat-icon>
      <h2 class="cb__title">{{strings['cookie_banner_title']}}</h2>
    </div>
    <p class="cb__text">{{strings['cookie_banner_text']}}</p>
    <p class="cb__text cb__text--small">
      {{strings['cookie_banner_change']}}
      <!-- A new tab: from the map, following a link would leave the visitor's work. -->
      <a class="cb__link" href="/cookies" target="_blank" rel="noopener">{{strings['cookie_policy']}}</a>
    </p>
    <!-- Reject and accept carry the same weight on purpose: same size, same
         style, side by side. The AEPD treats a faint "reject" as nudging. -->
    <div class="cb__actions">
      <button class="cb__btn" type="button" (click)="consent.rejectAll()">{{strings['cookie_reject_optional']}}</button>
      <button class="cb__btn" type="button" (click)="consent.acceptAll()">{{strings['cookie_accept_all']}}</button>
    </div>
    <button class="cb__customize" type="button" (click)="consent.openSettings()">
      <mat-icon aria-hidden="true">tune</mat-icon>{{strings['cookie_customize']}}
    </button>
  </section>
}
